import React, { useState } from "react";
import axios from "axios";
import ChunkBinary from "./ChunkBinary";

// Set CHUNK_SIZE to 3MB (below API Gateway’s 4MB limit)

const ChunkTest64 = () => {
  const chunkSize = 3 * 1024 * 1024; // 3MB
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0); // Track upload progress

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadProgress(0); // Reset progress on file change
  };

  // Function to convert a chunk to Base64
  const fileToBase64 = (chunk) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(chunk); // Read as Base64
      reader.onload = () => resolve(reader.result.split(",")[1]); // Remove the prefix
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadChunk = async (base64Data, index, totalChunks) => {
    const payload = {
      file: base64Data, // Send Base64 data in the payload
    };

    try {
      await axios.post(
        "https://16vi1kabu6.execute-api.ap-southeast-1.amazonaws.com/Demo/curd-r1" +
          `?fileName=${file.name}&chunkIndex=${index}&totalChunks=${totalChunks}`,
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log(`Uploaded chunk ${index + 1} / ${totalChunks}`);
    } catch (error) {
      console.error(`Error uploading chunk ${index + 1}:`, error);
      throw error; // Stop if any chunk fails
    }
  };

  const uploadChunks = async (formData, index, totalChunks) => {
    try {
      await axios.post("http://52.77.253.154:5000/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const chunkProgress = Math.round((loaded / total) * 100);
          const totalProgress = Math.round(
            ((index + chunkProgress / 100) / totalChunks) * 100
          );
          setUploadProgress(totalProgress);
        },
      });
      console.log(`Uploaded chunk ${index + 1} / ${totalChunks}`);
    } catch (error) {
      console.error(`Error uploading chunk ${index + 1}:`, error);
      throw error; // Stop if any chunk fails
    }
  };
  const handleUpload = async () => {
    if (!file) return;
    const totalChunks = Math.ceil(file.size / chunkSize);
    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = start + chunkSize;
      const chunk = file.slice(start, end);
      const formData = new FormData();
      formData.append("chunk", chunk);
      formData.append("filename", file.name);
      formData.append("chunkIndex", i);
      formData.append("totalChunks", totalChunks);
      formData.append("projectKey", "Test_Medical_Imaging");
      formData.append("datasetName", "MedicalImage");
      formData.append("siteName", "Singapore");
      formData.append("bucketName", "federated-learning-platform"); // http://52.77.253.154:5000/upload      // https://16vi1kabu6.execute-api.ap-southeast-1.amazonaws.com/crudDemoTest
      await uploadChunks(formData, i, totalChunks);

      // await axios.post("http://52.77.253.154:5000/upload ", formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // });
    }
  };

  // const handleUpload = async () => {
  //   if (!file) return alert("Please select a file to upload.");

  //   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

  //   for (let i = 0; i < totalChunks; i++) {
  //     const start = i * CHUNK_SIZE;
  //     const end = Math.min(start + CHUNK_SIZE, file.size);
  //     const chunk = file.slice(start, end);

  //     const base64Data = await fileToBase64(chunk); // Convert chunk to Base64

  //     await uploadChunk(base64Data, i, totalChunks); // Upload each chunk

  //     // Update progress after each chunk
  //     const progress = Math.round(((i + 1) / totalChunks) * 100);
  //     setUploadProgress(progress);
  //   }

  //   alert("File uploaded successfully!");
  // };

  return (
    <div className="p-4">
      <h1>
        <b>Test</b>
      </h1>
      <input type="file" onChange={handleFileChange} className="mb-2" />
      <button
        onClick={handleUpload}
        className="bg-blue-500 text-white px-4 py-2 rounded"
      >
        Upload File
      </button>
      {uploadProgress > 0 && (
        <div className="mt-4">
          <p>Upload Progress: {uploadProgress}%</p>
          <div className="w-full bg-gray-200 rounded h-4">
            <div
              className="bg-blue-500 h-4 rounded"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
        </div>
      )}
      <hr></hr>
      {/* <div className=" bg-cyan-300">
        <ChunkBinary />
      </div> */}
    </div>
  );
};

export default ChunkTest64;
